import React from 'react';
import { OverviewStats as Stats } from '../types';
import StatCard from './StatCard';
import styles from '../../../../../../styles/OverviewTab.module.css';

interface OverviewStatsProps {
  stats: Stats;
}

const OverviewStats: React.FC<OverviewStatsProps> = ({ stats }) => {
  return (
    <div className={styles.statsGrid}>
      <StatCard
        title="Total Members"
        value={stats.total_members}
        icon={
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        }
        changeText="Active members"
        changeType="positive"
      />

      <StatCard
        title="Active Tasks"
        value={stats.total_tasks - stats.completed_tasks}
        icon={
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 11l3 3L22 4"></path>
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
          </svg>
        }
        changeText={`${stats.total_tasks - stats.completed_tasks} in progress`}
        changeType="positive"
      />

      <StatCard
        title="Points Earned"
        value={stats.total_points}
        icon={
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518z"/>
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
            <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11m0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/>
          </svg>
        }
        changeText="Total points earned"
        changeType="positive"
      />

      <StatCard
        title="Completion Rate"
        value={stats.completion_rate}
        icon={
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22,4 12,14.01 9,11.01"></polyline>
          </svg>
        }
        changeText={`${stats.completed_tasks}/${stats.total_tasks} completed`}
        changeType={stats.completion_rate >= 80 ? 'positive' : 'neutral'}
        suffix="%"
      />
    </div>
  );
};

export default OverviewStats;

